<template xmlns="http://www.w3.org/1999/html">
    <v-app>

        <!--        src="https://picsum.photos/1920/1080?random"-->
        <!--        scroll-target="#scrolling-techniques-5"-->
        <!--        scroll-threshold="500"-->
        <!--        fade-img-on-scroll-->
        <!--        shrink-on-scroll-->
        <!--        shrink-on-scroll-->
        <!--        height="80"-->

        <!-- Removed prominent as it was causing version number to scroll on the users tab, where there are a lot of user groups -->

        <v-app-bar :class="{'darken-3': isDark}" :color="isDark ? 'primary' : 'white'" app class="top-level-responsive-sides-padding"
                   elevation="4" height="86">

            <v-container class="d-flex my-auto flex-row justify-space-between mw-100">
                <!--                <v-system-bar
                                    window
                                    fixed
                                    color="red"
                                    lights-out
                                >
                                    <v-icon v-text="icons.mdiCarBrakeAlert"></v-icon>
                                    <span class="font-weight-bold subtitle-1">SOS is Active</span>
                                    <v-spacer></v-spacer>
                                    <span>Time Remaining: 10 minutes</span>
                                    <v-icon class="ml-2">mdi-close</v-icon>
                                </v-system-bar>-->

                <v-row>

                    <v-col class="pa-0 mw-100" cols="12" md="4">
                        <!-- max-width="300" width="200" -->
                        <!--                        <v-img src="img/shelterfilter.png" class="w-100" max-width="300"></v-img>-->
                        <!-- without max width it is stretching way too much -->
                        <!--                        ma-auto-->
                        <div class="position-relative mw-300">
                            <!--v-if="!isDevelopmentEnvironment"-->
                            <img
                                 :src="isDark ? 'img/lightphone-dark.png': 'img/lightphone-light.png'"
                                 class="w-100"/>
                            <!--                            <span class="version-logo subtitle-2 font-weight-light font-italic" v-text="appVersion"></span>-->
                        </div>
                    </v-col>
                    <v-col class="pa-0 align-center justify-end d-none d-md-flex connections-autocomplete-wrapper" cols="12"
                           md="8">

                        <!--                            :loading="saveProgressBar ? 'white' : false"-->
                        <!--                            loader-height="3"-->
                        <!--                        :dense="!currentConnectionAutocompleteInFocus"-->
                        <!--                        @input="validateFtpConnectionBeforeConfirmChangeOfConnection($event)"-->

                        <v-select
                            v-if="isNotFtpOnlyMode"
                            v-show="isHome && hasAtLeastOneFtpConnection"
                            ref="currentConnectionRef"
                            :append-icon="icons.mdiPlusCircle" :dense="!currentConnectionAutocompleteInFocus"
                            :disabled="saveProgressBar"
                            :item-text="function (item) { return item.key; }" 
                            :item-value="function (item) { return { value: item.value, key: item.key }; }" 
                            :items="connections"
                            :rounded="!currentConnectionAutocompleteInFocus"
                            :value="currentConnection" class="max-width-450 font-weight-bold connections-autocomplete"
                            hide-details
                            label="Connections"
                            solo-inverted
                            @blur="currentConnectionAutocompleteInFocus = false"
                            @focus="currentConnectionAutocompleteInFocus = true" 
                            @input="validateFtpConnectionBeforeConfirmChangeOfConnection($event)"
                        >
                            <template slot="append">
                                <v-btn v-show="hideForLocalConnection && !saveProgressBar" class="mx-1" icon small
                                       @click.native.stop="openAddEditConnectionDialog('edit', currentConnection.key, currentConnection.value.server, currentConnection.value.username, currentConnection.value.password)">
                                    <v-icon :class="{'text--darken-3': !isDark}" :color="currentConnectionAutocompleteInFocus ? (!isDark? 'grey' : 'primary') : ''"
                                            v-text="icons.mdiPencilCircle"></v-icon>
                                </v-btn>
                                <v-btn v-show="!saveProgressBar" class="mx-1" icon small
                                       @click.native.stop="openAddEditConnectionDialog('add')">
                                    <v-icon :class="{'text--darken-3': !isDark}" :color="currentConnectionAutocompleteInFocus ? (!isDark? 'grey' : 'primary') : ''"
                                            v-text="icons.mdiPlusCircle"></v-icon>
                                </v-btn>
                                <v-btn v-show="!saveProgressBar && hideForLocalConnection" class="ml-1" icon small
                                       @click.native.stop="configConnectionDelete()">
                                    <v-icon :class="{'text--darken-3': !isDark}" :color="currentConnectionAutocompleteInFocus ? (!isDark? 'grey' : 'primary') : ''"
                                            v-text="icons.mdiDeleteCircle"></v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:selection="{ parent, item, index, select, selected, disabled }">
                                <v-chip v-show="item?.value?.hasOwnProperty('type') && item?.value?.type" :color="isDark ? 'primary' : 'secondary'"
                                        class="mr-3" small>
                                    {{
                                        item?.value?.type
                                    }}
                                </v-chip>
                                <span v-show="item" class="text-truncate">{{ item.key | capitalize }}</span>
                            </template>
                            <template v-slot:item="{ parent, item, on, attrs }">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.key | capitalize }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle
                                        v-if="item?.value?.hasOwnProperty('type') && item?.value?.type !== 'local'">
                                        {{ item.value.type }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-select>
                        <!--
                        <v-btn icon v-if="isHome">
                            <v-icon v-text="icons.mdiInformationOutline"></v-icon>
                        </v-btn>
                        -->
                        <!-- Hidden for now - may be useful one day -->
                        <v-btn v-if="isHome && false" :title="$gettext('Where? & Why?')" icon @click="openSupportDialog()">
                            <v-icon v-text="icons.mdiHelpCircleOutline"></v-icon>
                        </v-btn>
                        <!-- Dark mode/ light mode switcher -->
                        <v-btn icon @click="toggleDarkMode()">
                            <v-icon v-text="isDark ? icons.mdiWhiteBalanceSunny : icons.mdiWeatherNight"></v-icon>
                        </v-btn>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">

                                <!-- <v-btn icon rounded class="mx-3 white primary&#45;&#45;text" v-if="isHome && isFtpOnlyMode" @click="logout()">
                                    <v-icon v-text="icons.mdiLogout"></v-icon>
                                </v-btn> -->

                                <!--<v-btn rounded class="elevation-2 font-weight-bold"
                                        title="Click to save all your changes."
                                        large color="white" cols="4" @click.native.prevent="configIdefix3Persist()"
                                        v-show="isHome" v-bind="attrs" v-on="on">
                                    <v-progress-circular :width="1" :size="18" color="grey" indeterminate
                                                            v-if="saveProgressBar"></v-progress-circular>
                                    
                                    <div v-else>
                                        <v-icon class="mr-2"
                                                :color="configHasUnsavedChanges()['status'] ? 'red' : 'secondary'"
                                                v-text="icons.mdiContentSave"></v-icon>
                                        <span class="secondary&#45;&#45;text subtitle-1 font-weight-bold"
                                                v-text="$gettext('Save')"></span>
                                    </div>
                                </v-btn>-->
                                
                                <!--:title="configHasUnsavedChanges()['status'] ? $gettext('You have unsaved changes') : $gettext('All your changes are saved!')"-->

                                <v-btn 
                                    icon rounded 
                                    :class="{
                                        'mx-2': true,
                                        'white': !hasUnsavedChanges,
                                        'primary--text': !hasUnsavedChanges,
                                        'save-button-unsaved': hasUnsavedChanges,
                                        'save-button-animate': shouldAnimateSaveButton
                                    }"
                                    @click.native.prevent="configIdefix3Persist()"
                                    v-show="isHome"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon v-if="!saveProgressBar" :color="configHasUnsavedChanges()['status'] ? 'red' : 'secondary'" v-text="icons.mdiContentSave"></v-icon>
                                    
                                    <v-progress-circular :width="1" :size="18" color="grey" indeterminate v-else></v-progress-circular>
                                </v-btn>
                                
                                </template>
                            <span>
                                <span v-if="saveProgressBar" v-text="$gettext('Just a moment...')"></span>
                                <span v-else-if="!configHasUnsavedChanges()['status']"
                                        v-text="$gettext('All your changes are saved!')"></span>
                                <span v-else v-text="$gettext('You have unsaved changes')"></span>
                            </span>
                        </v-tooltip>

                    </v-col>
                    <!--  Only for desktop, for mobile see below -->
                    <!--                    <v-col cols="12" md="2" class="text-right pa-0 align-center justify-end d-none d-md-flex">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">

                                                    &lt;!&ndash; <v-btn icon rounded class="mx-3 white primary&#45;&#45;text" v-if="isHome && isFtpOnlyMode" @click="logout()">
                                                        <v-icon v-text="icons.mdiLogout"></v-icon>
                                                    </v-btn> &ndash;&gt;

                                                    <v-btn rounded class="elevation-2 font-weight-bold"
                                                           title="Click to save all your changes."
                                                           large color="white" cols="4" @click.native.prevent="configIdefix3Persist()"
                                                           v-show="isHome" v-bind="attrs" v-on="on">
                                                        <v-progress-circular :width="1" :size="18" color="grey" indeterminate
                                                                             v-if="saveProgressBar"></v-progress-circular>
                                                        &lt;!&ndash;                                    <v-img src="public/img/ios-spinner.png" max-width="30" v-if="!saveProgressBar"></v-img>&ndash;&gt;
                                                        <div v-else>
                                                            <v-icon class="mr-2"
                                                                    :color="configHasUnsavedChanges()['status'] ? 'red' : 'secondary'"
                                                                    v-text="icons.mdiContentSave"></v-icon>
                                                            <span class="secondary&#45;&#45;text subtitle-1 font-weight-bold"
                                                                  v-text="$gettext('Save')"></span>
                                                        </div>
                                                    </v-btn>

                                                    &lt;!&ndash;
                                                                                    <v-btn icon rounded class="mx-2 white primary&#45;&#45;text">
                                                                                        <v-icon v-text="icons.mdiContentSave"></v-icon>
                                                                                    </v-btn>&ndash;&gt;
                                                </template>
                                                <span>
                                                    <span v-if="saveProgressBar" v-text="$gettext('Just a moment...')"></span>
                                                    <span v-else-if="!configHasUnsavedChanges()['status']"
                                                          v-text="$gettext('All your changes are saved!')"></span>
                                                    <span v-else v-text="$gettext('You have unsaved changes')"></span>
                                                </span>
                                            </v-tooltip>
                                        </v-col>-->
                </v-row>
            </v-container>

            <v-app-bar-nav-icon v-show="isHome" class="ma-auto" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <!-- Mobile Version (For desktop, see above) -->
            <v-btn v-if="isHome" v-show="isHome" :color="isDark ? 'primary--text' : 'white'" :title="$gettext('Click to save all your changes.')" class="d-md-none ma-auto"
                   fab
                   icon small @click.native.prevent="configIdefix3Persist()">
                <v-icon :color="configHasUnsavedChanges()['status'] ? 'red' : 'white'"
                        :title="$gettext('Click to save all your changes.')"
                        v-text="icons.mdiContentSave"></v-icon>
            </v-btn>
            <template v-if="isHome" v-slot:extension>

                <v-tabs v-if="isHome" v-model="currentTab" :align-with-title="$vuetify.breakpoint.mdAndUp" centered class="px-0" fixed-tabs
                        show-arrows>
                    <v-tab v-for="(tab, index) in tabs" :key="index"
                           :active-class="isDark ? 'secondary--text text--lighten-4 lighten-4' : ''">

                        <!--                        <v-icon v-if="index === 'users' && $vuetify.breakpoint.mdAndUp"-->
                        <!--                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }"-->
                        <!--                                v-text="icons.mdiAccountGroup"></v-icon>-->
                        <!--                        <v-icon v-if="index === 'filter' && $vuetify.breakpoint.mdAndUp"-->
                        <!--                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }" v-text="icons.mdiWeb"></v-icon>-->
                        <v-icon v-if="index === 'categories' && $vuetify.breakpoint.mdAndUp"
                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }"
                                v-text="icons.mdiViewListOutline"></v-icon>
                        <!--                        <v-icon v-if="index === 'info' && $vuetify.breakpoint.mdAndUp"-->
                        <!--                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }" v-text="icons.mdiInformation"></v-icon>-->


                        <v-icon v-if="index === 'usageTime' && $vuetify.breakpoint.mdAndUp"
                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }"
                                v-text="icons.mdiClockOutline"></v-icon>

                        <span v-if="$vuetify.breakpoint.smAndDown && index === 'usageTime'"
                              class="caption font-weight-bold"
                              v-text="$gettext('Usage Time')"></span>
                        <span v-if="$vuetify.breakpoint.mdAndUp && index === 'usageTime'"
                              v-text="$gettext('Usage Time')"></span>

                        <v-icon v-if="index === 'personalControls' && $vuetify.breakpoint.mdAndUp"
                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }"
                                v-text="icons.mdiLockOutline"></v-icon>

                        <span v-if="$vuetify.breakpoint.smAndDown && index === 'personalControls'"
                              class="caption font-weight-bold"
                              v-text="$gettext('Personal Controls')"></span>
                        <span v-if="$vuetify.breakpoint.mdAndUp && index === 'personalControls'"
                              v-text="$gettext('Personal Controls')"></span>


                        <span v-if="$vuetify.breakpoint.smAndDown && index === 'categories'"
                              class="caption font-weight-bold"
                              v-text="$gettext('Web Filter')"></span>
                        <span v-if="$vuetify.breakpoint.mdAndUp && index === 'categories'"
                              v-text="$gettext('Web Filter')"></span>

                        <span v-if="$vuetify.breakpoint.smAndDown && index === 'security'"
                              class="caption font-weight-bold"
                              v-text="$gettext('Security Settings')"></span>
                        <span v-if="$vuetify.breakpoint.mdAndUp && index === 'security'"
                              v-text="$gettext('Security Settings')"></span>


                        <v-icon v-if="index === 'groups' && $vuetify.breakpoint.mdAndUp"
                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }"
                                v-text="icons.mdiSelectGroup"></v-icon>
                        <v-icon v-if="index === 'applications' && $vuetify.breakpoint.mdAndUp"
                                :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }"
                                v-text="icons.mdiCellphoneCog"></v-icon>

                        <!--                        <span v-text="$gettext('Users')" v-if="$vuetify.breakpoint.smAndDown && index === 'users'"-->
                        <!--                              class="caption font-weight-bold"></span>-->
                        <!--                        <span v-text="$gettext('Users')" v-if="$vuetify.breakpoint.mdAndUp && index === 'users'"></span>-->

                        <!--                        <span v-text="$gettext('Rules')"-->
                        <!--                              v-if="$vuetify.breakpoint.smAndDown && index === 'filter'"-->
                        <!--                              class="caption font-weight-bold"></span>-->
                        <!--                        <span v-text="$gettext('Rules')"-->
                        <!--                              v-if="$vuetify.breakpoint.mdAndUp && index === 'filter'"></span>-->


                        <!--                        <span v-text="$gettext('Information')" v-if="$vuetify.breakpoint.smAndDown && index === 'info'"-->
                        <!--                              class="caption font-weight-bold"></span>-->
                        <!--                        <span v-text="$gettext('Information')"-->
                        <!--                              v-if="$vuetify.breakpoint.mdAndUp && index === 'info'"></span>-->

                        <span v-if="$vuetify.breakpoint.smAndDown && index === 'groups'" class="caption font-weight-bold"
                              v-text="$gettext('Groups')"></span>
                        <span v-if="$vuetify.breakpoint.mdAndUp && index === 'groups'"
                              v-text="$gettext('Groups')"></span>

                        <span v-if="$vuetify.breakpoint.smAndDown && index === 'applications'"
                              class="caption font-weight-bold"
                              v-text="$gettext('Mobile Apps')"></span>
                        <span v-if="$vuetify.breakpoint.mdAndUp && index === 'applications'"
                              v-text="$gettext('Mobile Apps')"></span>

                        <span v-if="$vuetify.breakpoint.smAndDown && index === 'security'"
                              class="caption font-weight-bold"
                              v-text="$gettext('Security Settings')"></span>

                    </v-tab>
                </v-tabs>

            </template>
        </v-app-bar>

        <v-navigation-drawer v-model="drawer" fixed right temporary width="280">

            <div class="d-flex display-1 align-center text-center justify-center font-weight-bold white--text pa-3"
                 style="background-color: black;">
                <v-img src="img/shelterfilter-dark3.png" width="200"></v-img>
                <!--                <span class="version-logo">{{ appVersion }}</span>-->
            </div>

            <v-divider></v-divider>

            <v-list dense nav shaped>
                <v-list-item-group v-model="group" active-class="primary--text">

                    <v-list-item v-if="!hasAtLeastOneFtpConnection && connectionsIsEnabled"
                                 @click.native.stop="openAddEditConnectionDialog('add')">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiPlusCircle"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Create a Connection Profile')"></v-list-item-title>
                    </v-list-item>

                    <v-list-item v-show="!connectionsMobileMenu && hasAtLeastOneFtpConnection && smAndDown && isNotFtpOnlyMode"
                                 class="mr-3"
                                 @click.native.stop="toggleConnectionsMobileMenu()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiFormatListBulletedTriangle"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-if="currentConnection.key"
                                           v-text="currentConnection.key"></v-list-item-title>
                        <v-list-item-title v-else>Show Connections</v-list-item-title>
                        <v-list-item-icon v-if="currentConnection.key !== 'local'" class="ml-auto mr-5">
                            <v-btn icon
                                   @click.native.stop="openAddEditConnectionDialog('edit', currentConnection.key, currentConnection.value.server, currentConnection.value.username, currentConnection.value.password)">
                                <v-icon v-text="icons.mdiPencilCircle"></v-icon>
                            </v-btn>

                            <v-btn icon @click.native.stop="openAddEditConnectionDialog('add')">
                                <v-icon v-text="icons.mdiPlusCircle"></v-icon>
                            </v-btn>
                            <v-btn icon @click.native.stop="configConnectionDelete()">
                                <v-icon v-text="icons.mdiDelete"></v-icon>
                            </v-btn>
                        </v-list-item-icon>
                    </v-list-item>

                    <v-list-item v-show="connectionsMobileMenu && hasAtLeastOneFtpConnection && smAndDown"
                                 @click.native.stop="toggleConnectionsMobileMenu()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiClose"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            <span v-if="currentConnection.key">{{ currentConnection.key }}</span>
                            <span v-else v-text="$gettext('Hide Connections')"></span>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item v-for="connection in connections" v-show="connectionsMobileMenu && hasAtLeastOneFtpConnection && connection.key !== currentConnection.key && smAndDown"
                                 :key="connection.key">
                        <v-list-item-icon class="ml-3">
                            <v-icon v-text="icons.mdiCircleSmall"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title @click="confirmChangeOfConnection(connection)"
                                           v-text="connection.key"></v-list-item-title>
                    </v-list-item>

                    <v-list-item :disabled="saveProgressBar"
                                 @click.prevent.native="!saveProgressBar ? openRestoreDialog() : ''">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiRestore"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Restore')"></v-list-item-title>
                    </v-list-item>

                    <v-list-item :disabled="saveProgressBar" @click.prevent.native="openTemplateDialog()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiFileDocumentMultipleOutline"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Templates')"></v-list-item-title>
                    </v-list-item>

                    <v-list-item :disabled="saveProgressBar" @click.prevent.native="downloadConfigurationFiles()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiDownloadCircleOutline"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Save configuration to disk')"></v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$vuetify.breakpoint.smAndDown" :disabled="saveProgressBar"
                                 @click.prevent.native="openSupportDialog">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiHelpCircleOutline"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Where?')"></v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$vuetify.breakpoint.smAndDown" :disabled="saveProgressBar"
                                 @click.prevent.native="toggleDarkMode()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="isDark ? icons.mdiWhiteBalanceSunny : icons.mdiWeatherNight"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                            v-text="isDark ? $gettext('Light mode') : $gettext('Dark mode')"></v-list-item-title>
                    </v-list-item>

                    <!-- notice the false in v-if-->
                    <v-list-item v-if="adminOptionsIsEnabled && false"
                                 :disabled="saveProgressBar" @click.prevent.native="!saveProgressBar ? openAdminOptionsDialog() : ''">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiTune"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Admin Options')"></v-list-item-title>
                    </v-list-item>

                    <!--                    <v-list-item @click.prevent.native="! saveProgressBar ? openSosDialog(): ''" :disabled="saveProgressBar">
                                            <v-list-item-icon class="mr-3">
                                                <v-icon v-text="icons.mdiCarBrakeAlert"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>SOS</v-list-item-title>
                                        </v-list-item>-->
                    <v-list-item @click.prevent.native="takeToDocumentation()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiFileDocumentOutline"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Documentation')"></v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="currentConnection?.value?.type === 'local'"
                                 @click.native.stop="openChangePasswordDialog()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiCogStop"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Change Password')"></v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.prevent.native="logoutIfWeHaveNoUnsavedChanges()">
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="icons.mdiLogoutVariant"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$gettext('Logout')"></v-list-item-title>
                    </v-list-item>

                    <!--<v-list-item class="black&#45;&#45;text">
                        <v-list-item-title>Confix {{ appVersion }}</v-list-item-title>
                    </v-list-item>-->

                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <router-view/>

        <dialog-connections-add-edit-connections
            v-if="addEditConnectionDialog"
            :add-edit-connection-dialog="addEditConnectionDialog"
            :connections-prop="connections"
            :in-edit-connection-current-invalid-ftp-connection-details="editConnectionCurrentInvalidFtpConnectionDetails"
            :in-edit-connection-name="editConnectionCurrentInvalidFtpConnectionDetails ? editConnectionCurrentInvalidFtpConnectionDetails.key : editConnectionNameField" :in-edit-connection-password="editConnectionPasswordField"
            :in-edit-connection-progress-bar="editConnectionProgressBar"
            :in-edit-connection-progress-bar-message="editConnectionProgressBarMessage"
            :in-edit-connection-server="editConnectionServerField"
            :in-edit-connection-username="editConnectionUsernameField"
            :mode="addEditConnectionMode"
            @close-add-edit-connection-dialog="function (dialogName) { closeAddEditConnectionDialog(dialogName) }"
            @connection-updated="(connectionToUpdate) => { processEditAConnection(connectionToUpdate) }"
        >
        </dialog-connections-add-edit-connections>
        <dialog-restore v-if="restoreDialog" :params="restoreParams"></dialog-restore>
        <dialog-template v-if="templateDialog" :params="templateParams"></dialog-template>
        <dialog-change-password v-if="changePasswordDialog" :params="changePasswordParams"></dialog-change-password>
        <dialog-admin-options v-if="adminOptionsDialog" :params="adminOptionsParams"></dialog-admin-options>
        <!--        <dialog-sos v-if="sosDialog" :params="sosParams"></dialog-sos>-->

        <dialog-support v-if="supportDialog" :params="supportParams"></dialog-support>

        <snackbar ref="snackbar"></snackbar>


    </v-app>
</template>

<script>

import Vue from 'vue'
import {version} from '../package'
import DialogConnectionsAddEditConnections from '@/components/dialogs/connections/DialogConnectionsAddEditConnections'
import MixinDialog from '@/mixins/MixinDialog'
import {useConnectionsStore} from '@/stores/ConnectionsStore'
import {mapState, mapWritableState} from 'pinia'
import MixinIcon from '@/mixins/MixinIcon'
import MixinConfig from '@/mixins/database/MixinConfig'
import Snackbar from '@/components/Snackbar'
import {findIndex, isEmpty} from 'lodash'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import MixinGenericFtp from '@/mixins/generic/MixinGenericFtp'
import MixinConfigConnection from '@/mixins/database/MixinConfigConnection'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinGenericHelper from '@/mixins/generic/MixinGenericHelper'
import {eventBus} from '@/main'
import {useProgressBarsStore} from '@/stores/ProgressBarStore'
import DialogRestore from '@/components/dialogs/restore/DialogRestore'
import DialogAdminOptions from '@/components/dialogs/admin_options/DialogAdminOptions'
import {useMainTabsStore} from '@/stores/MainTabStore'
import MixinAuthentication from '@/mixins/MixinAuthentication'
import DialogChangePassword from '@/components/dialogs/change_password/DialogChangePassword'
import DialogSos from '@/components/dialogs/DialogSos'
import DialogTemplate from '@/components/dialogs/restore/DialogTemplate'
import {useAdminOptionsStore} from '@/stores/AdminOptionsStore'
import {useLoginStore} from "@/stores/LoginStore";
import Constants from "@/assets/js/constants";
import MixinDark from "@/mixins/database/MixinDark";
import {useGeneralStore} from "@/stores/GeneralStore";
import DialogSupport from "@/components/dialogs/support/DialogSupport.vue";
import {useIdefix3AdditionalFields} from "@/stores/Idefix3AdditionalFieldsStore";
import { useAuthenticationStore } from '@/stores/AuthenticationStore'


export default {
    name: 'App',
    components: {
        DialogSupport,
        DialogTemplate,
        DialogChangePassword,
        DialogConnectionsAddEditConnections,
        Snackbar,
        DialogRestore,
        DialogAdminOptions,
        DialogSos
    },
    data: () => ({
        appVersion: version,
        drawer: false,
        group: null,
        connectionsMobileMenu: false,
        // cC: '',

        addEditConnectionDialog: false,
        addEditConnectionMode: 'add',
        editConnectionNameField: '',
        editConnectionServerField: '',
        editConnectionUsernameField: '',
        editConnectionPasswordField: '',
        editConnectionProgressBar: '',
        editConnectionProgressBarMessage: '',
        /**
         *
         * @var editConnectionCurrentInvalidFtpConnectionDetails
         *
         * when a connection is changed from the drop down, and the desired connection is invalid, the user is offered to edit, upon edit the connection is validated, and when found it's invalid, this gets set! This gets unset when the edit connection is saved, when closing the dialog.
         *
         * If typeof following is object i.e. it is set, know that the information received at the time of edit for the connection is invalid (ftp).
         * It can also be put as, presence of this field means that an external connection edit is opened. i.e. the user would have previous successful connection as the current connection. Because, when the system detects that the connection is invalid, it reverts back the connection to the previous connection. However, user is given an opportunity to edit the connection with the error and fix the error. This variable plays a supporting role there.
         *  */
        editConnectionCurrentInvalidFtpConnectionDetails: false,

        restoreDialog: false,
        restoreParams: '',

        templateDialog: false,
        templateParams: '',

        adminOptionsDialog: false,
        adminOptionsParams: '',

        sosDialog: false,
        sosParams: '',

        changePasswordDialog: false,
        changePasswordParams: '',

        currentConnectionAutocompleteInFocus: false,

        supportDialog: false,
        supportParams: '',

        isDevelopmentEnvironment: Constants.isDevelopmentEnvironment,

        hasUnsavedChanges: false,
        shouldAnimateSaveButton: false

    }),

    mixins: [MixinDialog, MixinIcon, MixinConfig, MixinSwalConfirmation, MixinGenericFtp, MixinConfigConnection, MixinStringManipulation, MixinGenericHelper, MixinAuthentication, MixinDark],
    computed: {

        isFtpOnlyMode() {
            return this.loginMode === Constants.login.ftpOnly
        },
        isNotFtpOnlyMode() {
            return this.loginMode !== Constants.login.ftpOnly
        },

        isHome() {
            return this.$route.name === 'Home'
        },

        smAndDown() {
            return this.$vuetify.breakpoint.smAndDown
        },

        hideForLocalConnection() {

            let self = this
            return (self.currentConnection.key !== 'local')

        },

        hasAtLeastOneFtpConnection() {
            let self = this
            return self.connections.length > 1
        },

        currentConnectionIsSet() {

            let self = this

            return !!(self.$route.name === 'Home' && self.currentConnection && self.currentConnection.hasOwnProperty('value') && self.currentConnection && self.currentConnection.hasOwnProperty('key') && self.currentConnection.key)

        },

        ...mapState(useAdminOptionsStore, {
            adminOptionsIsEnabled: 'isEnabled'
        }),

        ...mapWritableState(useConnectionsStore, {
            currentConnection: 'currentConnection',
            connectionHistory: 'connectionHistory',
            connections: 'connections',
            connectionsIsEnabled: 'isEnabled',
        }),

        ...mapWritableState(useProgressBarsStore, {
            saveProgressBar: 'saveProgressBar',
        }),

        ...mapWritableState(useMainTabsStore, {
            currentTab: 'currentTab',
            tabs: 'tabs'
        }),

        ...mapWritableState(useLoginStore, {
            loginMode: 'loginMode'
        }),

        ...mapWritableState(useGeneralStore, {
            beforeunloadListenerTracker: 'beforeunloadListenerTracker'
        }),

        hasUnsavedChangesComputed() {
            return this.configHasUnsavedChanges()['status']
        }

    },
    methods: {

        logoutIfWeHaveNoUnsavedChanges() {

            let self = this;

            if (self.configHasUnsavedChanges()['status']) {

                self.swalConfirmation({
                    icon: 'warning',
                    title: self.$gettext('You have unsaved changes'),
                    description: self.$gettext('Are you sure you want to logout?'),
                    confirmButtonText: self.$gettext('Logout'),
                    cancelButtonText: self.$gettext('Cancel'),
                    showCancelButton: true,
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                    successCallback: (answer) => {

                        if (answer) {

                            self.beforeunloadListenerTracker = 'exitListening'
                            // self.configHasUnsavedChanges(); // so that above is trigerred sooner

                            // setTimeout(() => {
                            self.logout()
                            // }, 1000);

                        }

                    },
                })

            } else {
                self.logout()
            }

        },

        closeAddEditConnectionDialog(dialogName) {
            let self = this
            self.closeDialog(dialogName)
            // self.addEditConnectionDialog = false;
            self.editConnectionCurrentInvalidFtpConnectionDetails = false
        },

        openRestoreDialog() {

            let self = this

            self.restoreDialog = true
            self.restoreParams = {
                restoreDialog: true,
            }

        },

        openTemplateDialog() {

            let self = this

            self.templateDialog = true
            self.templateParams = {
                templateDialog: true,
            }

        },

        async downloadConfigurationFiles() {

            let self = this

            const alertErrorOccurred = () => {
                self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! Error occurred while downloading the configuration file'), 'error')
            }
            const alertDownloadInitiated = () => {
                self.$refs.snackbar.showSnackbar(self.$gettext('Download request is initiated.'), 'success', 'bottom-end', 30000)
            }

            try {

                alertDownloadInitiated()
                let downloadResponse = await self.configDownload()

                /**
                 * The response code of 500 is sent if something is wrong on the server side
                 */
                if (downloadResponse && downloadResponse.status === 200 && downloadResponse.hasOwnProperty('data') && downloadResponse.data) {

                    self.$refs.snackbar.hideSnackbar()

                    const url = window.URL.createObjectURL(new Blob([downloadResponse.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'configurations.zip')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                } else {
                    alertErrorOccurred()
                }

            } catch (e) {
                alertErrorOccurred()
                console.error(e)
            }

        },

        openChangePasswordDialog() {

            let self = this

            self.changePasswordDialog = true
            self.changePasswordParams = {
                changePasswordDialog: true,
            }

        },
        openAdminOptionsDialog() {

            let self = this

            self.adminOptionsDialog = true
            self.adminOptionsParams = {
                adminOptionsDialog: true,
            }

        },
        openSosDialog() {

            let self = this

            self.sosDialog = true
            self.sosParams = {
                sosDialog: true,
            }

        },

        openSupportDialog() {
            let self = this
            self.supportDialog = true
            self.supportParams = {
                supportDialog: true,
            }
        },

        toggleConnectionsMobileMenu() {

            this.keepDrawerOpen()
            let self = this
            self.connectionsMobileMenu = !self.connectionsMobileMenu
            this.keepDrawerOpen()
            return false
        },

        /**
         *
         * This is called from Home.vue when an invalid connection, fails to load.
         * */
        openAddEditConnectionEventHandler(currentInvalidFtpConnectionDetails = false) {

            let self = this

            this.openAddEditConnectionDialog('edit', self.currentConnection.key, self.currentConnection.value.server, self.currentConnection.value.username, self.currentConnection.value.password, currentInvalidFtpConnectionDetails)

        },

        getLocalConnection() {

            let self = this

            let connections = self.connections.filter((connection) => {
                return connection.key === 'local'
            })

            if (connections && connections.length > 0) {
                return connections[0]
            }
            return false
        },

        fallbackCurrentConnectionToLocalEvent(error = false) {

            let self = this
            let localConnection = this.getLocalConnection()

            if (localConnection) {

                this.currentConnection = localConnection

                eventBus.$emit('currentConnectionChanged', {
                    value: localConnection,
                    oldValue: {
                        'key': self.editConnectionNameField,
                        'value': {
                            'server': self.editConnectionServerField,
                            'username': self.editConnectionUsernameField,
                            'password': self.editConnectionPasswordField
                        }
                    },
                    operation: 'change',
                    saved: false,
                    oldEditConnectionNameField: self.editConnectionNameField,
                })

            }

        },

        /**
         *
         * When connection is changed to ftp, the connection is validated first, if found invalid, popup is displayed, with the option to edit the connection.
         * Otherwise, the function confirmChangeOfConnection is called.
         *
         *
         *
         * @param connection
         * @returns {Promise<void>}
         */
        async validateFtpConnectionBeforeConfirmChangeOfConnection(connection) {

            let self = this
            self.closeConnectionDropDown()

            const connectionsStore = useConnectionsStore()

            if (connection?.value?.type?.toLowerCase() === 'ftp') {

                self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Validating %{ connectionName }. Just a moment.'), {connectionName: connection.key}), 'info', 'bottom-end', 5000)

                self.saveProgressBar = true
                const isConnectionValid = await connectionsStore.validateConnectionAndUpdateConnections(connection)
                self.saveProgressBar = false

                if (isConnectionValid < 1) {

                    // What we see in autocomplete and what vue knows could be different. If for vue they both are the same the old value and the new value, vue won't do a thing. We know the following is to replaced by previous connection but since we want to have vue realize the change, we are setting current invalid connection, which is to be replaced by previous connection.

                    connectionsStore.setCurrentConnection(connection)
                    await self.$nextTick()

                    // Since the ftp connection is not valid, we can let the current connection to fallback to previous connection.
                    let previousConnection = connectionsStore.getPreviousConnectionFromConnectionHistoryIfItExists()
                    let connectionToSaveForEditConnection = false

                    if (previousConnection) {
                        await self.$nextTick(() => Vue.set(self, 'currentConnection', previousConnection))
                        connectionToSaveForEditConnection = previousConnection
                    } else {
                        // Safety net: This is not expected to happen. But if it does, we fallback to local connection.
                        await self.$nextTick(() => Vue.set(self, 'currentConnection', self.getLocalConnection()))
                        connectionToSaveForEditConnection = self.getLocalConnection()
                    }

                    const fnEditConnection = () => self.openAddEditConnectionDialog('edit', connection.key, connection.value.server, connection.value.username, connection.value.password, connection)

                    const fnDeleteConnection = () => {
                        self.configConnectionDelete(connection)
                    }

                    const connectionObj = {connection: connection.key}
                    const swalOptions = {
                        successCallback: fnEditConnection,
                        title: self.$gettext('Whoops!'),
                        description: self.$gettextInterpolate(self.$gettext('Error occurred while connecting to %{ connection }.'), connectionObj),
                        confirmButtonText: self.$gettextInterpolate(self.$gettext('Edit %{ connection }'), connectionObj),
                        icon: 'error',
                        denyButtonText: self.$gettextInterpolate(self.$gettext('Delete %{ connection }'), connectionObj),
                        denyCallback: fnDeleteConnection,
                        allowOutsideClick: false,
                    }

                    self.swalConfirmation(swalOptions)

                } else {
                    self.confirmChangeOfConnection(connection)
                }

            } else {
                self.confirmChangeOfConnection(connection)
            }

        },

        /**
         * For unsaved changes, popup for confirmation is displayed. Upon save confirmation, the connection is saved and the connection is changed, connection history is logged, and the event currentConnectionChanged is fired.
         * For no unsaved changes, same steps are followed, except the popup for save confirmation is not displayed.
         * @param connection
         */
        confirmChangeOfConnection(connection) {

            let self = this
            const connectionsStore = useConnectionsStore()

            const changeConnection = () => {

                connectionsStore.setConnectionHistory(connection)
                self.currentConnection = connection

                useAuthenticationStore().logUserIn({
                    account: connection.key,
                })

                self.$nextTick(() => {

                    eventBus.$emit('currentConnectionChanged', {
                        
                        value: connection,
                        oldValue: {
                            'key': self.editConnectionNameField,
                            'value': {
                                'server': self.editConnectionServerField,
                                'username': self.editConnectionUsernameField,
                                'password': self.editConnectionPasswordField
                            }
                        },
                        operation: 'change',
                        saved: false,
                        oldEditConnectionNameField: self.editConnectionNameField,
                    })

                })

            }

            if (self.currentConnectionIsSet) {

                let successCallback = function (s) {

                    self.configIdefix3Persist().then(function (response) {
                        changeConnection()
                    }).catch(function (e) {
                        // Todo: handle this
                    })
                    // Further actions are done in the home.vue file. Check the watch.
                }

                /* This is disabled because there's a bug here but also now we have more functionalities so there is no real loss with having this commented.
                     More about the bug: From scratch, added three connections with do not connect now (in the checkbox). Go to one of the created connection edit it and do not save it.
                     Change connection and then do cancel. The autocomplete is then blank. */
                /*let cancelCallback = function (s) {

                    let index = self.connectionHistory.length;
                    index--;

                    if (index < 0) {
                        index = 0;
                    }

                    // self.$refs.currentConnectionRef.$el.querySelector('input').value = self.connectionHistory.value[index].key;
                    Vue.set(self, 'currentConnection', self.connectionHistory[index]);

                };*/

                if (self.configHasUnsavedChanges()['status']) {

                    /* This is disabled because there's a bug here but also now we have more functionalities so there is no real loss with having this commented.
                     More about the bug: From scratch, added three connections with do not connect now (in the checkbox). Go to one of the created connection edit it and do not save it.
                     Change connection and then do cancel. The autocomplete is then blank. */
                    /* cancelButtonText: 'Cancel', cancelCallback: cancelCallback,*/
                    let swalOptions = {
                        icon: 'warning',
                        confirmButtonText: self.$gettext('Save and Change'),
                        successCallback,
                        title: self.$gettext('You have unsaved Changes'),
                        description: self.$gettext('When a connection is changed, any unsaved changes are lost.'),
                        successText: self.$gettext('Connection Changed!'),
                        cancelButtonText: self.$gettext('Change without saving'),
                        cancelCallback: changeConnection,
                    }

                    self.swalConfirmation(swalOptions)

                } else {
                    changeConnection()
                }

            } else {
                changeConnection()
            }

        },

        /**
         * Otherwise the dropdown is opened upon click.
         */
        closeConnectionDropDown() {
            let self = this
            self.$refs.currentConnectionRef.blur()
        },

        openAddEditConnectionDialog(mode, connectionName = '', server = '', username = '', password = '', currentInvalidFtpConnectionDetails = false) {

            let self = this

            self.addEditConnectionDialog = true
            self.addEditConnectionMode = mode
            self.editConnectionNameField = connectionName
            self.editConnectionServerField = server
            self.editConnectionUsernameField = username
            self.editConnectionPasswordField = password
            self.editConnectionProgressBar = false
            self.editConnectionCurrentInvalidFtpConnectionDetails = currentInvalidFtpConnectionDetails

            self.closeConnectionDropDown()

        },

        fallbackToLocalIfCurrentConnectionIsNotSet() {

            let self = this

            self.$nextTick(function () {

                // Fallback to local if no connection is set.
                if (!self.genericHelperIsSet(self.currentConnection)) {

                    let filteredConnection = self.connections.filter(function (c) {
                        return c.key.toLowerCase() === 'local'
                    })

                    if (self.genericHelperIsSet(filteredConnection)) {
                        // self.cC = filteredConnection[0];
                        self.currentConnection = filteredConnection[0]
                    }

                }

            })

        },

        async processEditAConnection(connectionToUpdate) {

            let self = this

            const connectionsStore = useConnectionsStore()
            let oldValue

            if (typeof self.editConnectionCurrentInvalidFtpConnectionDetails === 'object') {

                oldValue = {
                    'key': self.editConnectionCurrentInvalidFtpConnectionDetails.key,
                    'value': {
                        'server': self.editConnectionCurrentInvalidFtpConnectionDetails.value.server,
                        'username': self.editConnectionCurrentInvalidFtpConnectionDetails.value.username,
                        'password': self.editConnectionCurrentInvalidFtpConnectionDetails.value.password,
                    }
                }

            } else {

                oldValue = {
                    'key': self.editConnectionNameField,
                    'value': {
                        'server': self.editConnectionServerField,
                        'username': self.editConnectionUsernameField,
                        'password': self.editConnectionPasswordField
                    }
                }
            }

            const closeDialog = async () => {

                await self.$nextTick(() => {
                    self.editConnectionCurrentInvalidFtpConnectionDetails = false
                })

                self.closeDialog('addEditConnectionDialog')

            }

            const updatedMessage = () => self.$refs.snackbar.showSnackbar(self.$gettext('Connection updated successfully'))

            self.configConnectionEditAConnectionAndUpdateConnectionHistory(connectionToUpdate.connection, self.editConnectionNameField)

            // For invalid connections, the current connection is pointing to a valid connection, we don;t want to update the current connection with the latest value as that could be invalid as well, and we are not even validating while editing a connection, only when switching a connection. Hence.
            if (typeof self.editConnectionCurrentInvalidFtpConnectionDetails !== 'object') {
                Vue.set(self, 'currentConnection', connectionToUpdate.connection)
            }

            connectionsStore.updateConnectionHistory(oldValue, connectionToUpdate.connection)
            connectionsStore.updateConnection(oldValue, connectionToUpdate.connection)

            self.genericLocalStorageSetItem('connections', self.connections)

            updatedMessage()
            closeDialog()

        },
        keepDrawerOpen() {
            this.drawer = true
        },
        takeToDocumentation() {
            window.open('https://sheltercom.idefix64.fr/?token=gG5uB-APWVlhAZV4HUnOfQsF085zr4EZ8P2KIZsrSDI', '_blank')
        }
    },
    beforeDestroy() {
        // Stop listening
        eventBus.$off('fallbackCurrentConnectionToLocalEvent', this.fallbackCurrentConnectionToLocalEvent)
        eventBus.$off('openAddEditCurrentConnectionEvent', this.openAddEditConnectionEventHandler)
        // eventBus.$off('changeConnectionEvent', this.confirmChangeOfConnection);
    },
    created() {

        eventBus.$on('fallbackCurrentConnectionToLocalEvent', this.fallbackCurrentConnectionToLocalEvent)
        eventBus.$on('openAddEditCurrentConnectionEvent', this.openAddEditConnectionEventHandler)
        // eventBus.$on('changeConnectionEvent', this.confirmChangeOfConnection)
        
        this.hasUnsavedChanges = this.configHasUnsavedChanges()['status']
    },
    watch: {

        group() {
            this.drawer = false
        },

        hasUnsavedChangesComputed(newVal, oldVal) {
            if (newVal && !oldVal) {
                this.shouldAnimateSaveButton = true
                setTimeout(() => {
                    this.shouldAnimateSaveButton = false
                }, 600)
            }
            this.hasUnsavedChanges = newVal
        }

    },
        /* Disabled because we are using eventbus now, soon to be removed
        currentConnection: {

            handler: function (newVal, oldVal) {

                let self = this;

                if (newVal && typeof newVal === 'object' && newVal !== self.cC) {
                    // self.cC = {};
                    // self.$nextTick(function () {
                    Vue.set(self, 'cC', newVal);
                    // })
                }

            },
            deep: true
        }*/
}
</script>
<style lang="scss" type="text/scss">
@import "~vuetify/src/styles/main.sass";
@import '../public/css/fonts.css';
@import './src/assets/scss/fonts.scss';


/*------------------------------------------------
    Global Styles Only Here
--------------------------------------------------*/


.cursor-move {
    cursor: move;
}

.cursor-pointer {
    cursor: pointer !important;
}

.cursor-default {
    cursor: default;
}

.rotate-90 {
    transform: rotate(90deg);
}

.rotate-270 {
    transform: rotate(270deg);
}

.position-relative,
.relative {
    position: relative;
}

.absolute {
    position: absolute;
}

.right-50 {
    right: 50px;
}

.break-word {
    word-break: break-word;
}

.version-logo {
    position: absolute;
    bottom: 3px;
    right: 0;
    transform: rotate(-3deg);
}

.max-width-400 {
    max-width: 400px
}

.max-width-450 {
    max-width: 450px
}

.primary--text {
    color: #004E7C;
}

/*------------------------------------------------
    Widths
--------------------------------------------------*/

.w-90 {
    width: 90%;
}

.w-100 {
    width: 100%;
}

.mw-100 {
    max-width: 100%;
}

.mw-300 {
    max-width: 300px;
}

/*------------------------------------------------
    Opacity
--------------------------------------------------*/
.o-60 {
    opacity: 0.6;
}


/*------------------------------------------------
    Heights
--------------------------------------------------*/

.h-100 {
    height: 100%;
}


// When the following autocomplete is in focus, the color white of the button merges with the background color. This is a fix for it.
.connections-autocomplete-wrapper .v-input--is-focused {
    .v-input__append-inner {
        .v-btn.v-btn--icon {
            color: #004E7C !important;
        }
    }
}

/*------------------------------------------------
    Footer
--------------------------------------------------*/

@media only screen and (min-width: 768px) {

    .footer-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.footer-wrapper {
    height: 60px;
    position: relative;
    text-align: center;
}


/*------------------------------------------------
    Debug CSS
--------------------------------------------------*/
.debug-border {
    border: 1px dotted red;
}

/**
TODO: We need to ensure the imported vuetify class is only loaded once.
Read more here: https://github.com/vuetifyjs/vuetify/issues/12646#issuecomment-730241301 and https://github.com/webpack-contrib/sass-loader/issues/145
 */
.top-level-responsive-sides-padding {
    @extend .px-1;
    @extend .px-sm-3;
}

/*------------------------------------------------
    Transitions
--------------------------------------------------*/


* {
    transition: font-size 30ms;
}

.save-button-unsaved {
    background-color: rgba(244, 67, 54, 0.1) !important;
    border: 1px solid rgba(244, 67, 54, 0.3) !important;
}

.save-button-animate {
    animation: save-button-pulse 0.6s ease-out;
}

@keyframes save-button-pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.15);
    }
    100% {
        transform: scale(1);
    }
}
</style>

